import React from "react";
import "./index.scss";
import HeroImage from "./../../assets/Images/article/blog-hero.svg";
import { useContactModal } from "../Modal/contactModalContext";

function ArticleBlog({ objectVal }) {
  // const { setOpenModal } = useContactModal();
  // console.log(objectVal.mega_view_image, "objectVal.mega_view_image");

  return (
    <>
      {/* <div className="fixedBtn" onClick={() => setOpenModal(true)}>
        Contact us
      </div> */}
      <div
        className="article-blog-hero"
        style={{
          backgroundImage: `url(${objectVal?.mega_view_image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="article-blog-hero__section body-container ">
          <div
            className="article-blog-hero__content"
            style={{
              width: objectVal.mega_view_image === "NULL" ? "100%" : "",
            }}
          >
            {objectVal?.type && (
              <h4 className="article-blog-hero__tag">{objectVal?.type}</h4>
            )}
            <div className="article-blog-hero__content__info">
              <h1
                className="article-blog-hero__title "
                style={{
                  color: objectVal.mega_view_image === "NULL" ? "#000" : "#fff",
                }}
              >
                {objectVal?.title}
              </h1>
            </div>
          </div>
        </div>
        <div className="article-header-overlay"></div>
      </div>
    </>
  );
}

export default ArticleBlog;
